module.exports = __webpack_public_path__ + "img/jet-fighter.71c1229f.svg";